import React from 'react'

import { thousandsFormatter } from 'aem-libs-react-ts/src/utils/Formatters'

interface IChartProps {
  dark?: boolean
  value: number
  label: string
  percent: string
  unit: string
  rf: string
}

const ChartBox = ({ value, label, dark, percent, rf, unit }: IChartProps) => (
  <div className='csas-bar-chart-box'>
    <div className='csas-bar-chart-box-inner' style={{ height: '100px' }}>
      <div
        className={
          'csas-bar-chart ' +
          (dark ? 'csas-bar-chart-dark' : 'csas-bar-chart-light')
        }
        style={{ height: percent }}
      >
        <span data-rf={rf}>{`${thousandsFormatter(value)} ${unit}`}</span>
      </div>
    </div>
    <div className='csas-bar-chart-description'>{label}</div>
  </div>
)

export { ChartBox }
